import { DSText } from '../DSText/DSText'
import { styled } from 'styled-components'

const StyledBadge = styled.span`
  border: 0;
  border-radius: 6px;
  padding: var(--grid-4) var(--grid-8);
  display: inline-flex;
  justify-content: center;

  &.primary {
    background-color: var(--colour-surface-brand-bold);
    color: var(--colour-text-primary);
  }

  &.secondary {
    background-color: var(--colour-surface-red-subtle);
    color: var(--colour-text-primary);
  }

  &.tertiary {
    background-color: var(--colour-surface-blue-bold);
    color: var(--colour-text-primary-inverse);
  }
`

type BadgeProps = {
  variant: 'primary' | 'secondary' | 'tertiary'
  children: React.ReactNode
}

export const DSBadge = ({ variant, children }: BadgeProps) => {
  const textColour = variant === 'tertiary' ? 'primary-inverse' : 'primary'

  return (
    <StyledBadge className={`${variant}`}>
      <DSText variant="fluid-label-100" colour={textColour}>
        {children}
      </DSText>
    </StyledBadge>
  )
}
